import React from 'react';
import { filterProps } from '../helpers';
import { Props } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const showOnetrustSettings = (): void => (window as any).OneTrust?.ToggleInfoDisplay();

export const RocheCookieBannerLink = ({ blok, slot }: Props): JSX.Element => {
  const { props } = filterProps(blok);

  return (
    <roche-text-link
      {...props}
      slot={slot}
      text={blok?.text}
      onClick={showOnetrustSettings}
    />
  );
};
